module.exports = __webpack_public_path__ + "static/media/operaciones.1a405bb1.svg";